export enum BenefitsKeys {
  health = 'health',
  picky = 'picky',
  weight = 'weight',
}
